import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HighlightNew } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-latest-news',
  templateUrl: './sample-latest-news.component.html',
  styleUrls: ['./sample-latest-news.component.scss']
})
export class SampleLatestNewsComponent implements OnInit {

  @Input() block: any;
  @Input() lang: string = '';
  public blocks: HighlightNew[] = [];
  public headerData = {
    titolo: '',
    labelLink: '',
    labelLinkUrl: ''
  }
  customOptionsNews: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1
      }
    },
    nav: false
  }

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.headerData = {
      titolo: this.block.titolo,
      labelLink: this.block.label_link,
      labelLinkUrl: ''
    }
    if (this.block.link) {
      this.headerData = {
        ...this.headerData,
        labelLinkUrl: this.block.link.url
      }
    }
    this.nodeService.getRowTypeView(this.lang, this.block.oggetto_view, this.block.tipo_view, this.block.preview).subscribe(res => {
      if (res.length > 4) {
        this.blocks = res.slice(0, 4);
      } else {
        this.blocks = res;
      }
    });
  }

}
